<nz-header [ngClass]="isLoggedIn ? 'logged' : null">
  <div class="navbar" [ngClass]="!isLoggedIn ? 'not-logged' : null">
    @if (isLoggedIn && userData) {
      <div class="hamburger-menu">
        <ul nz-menu nzMode="horizontal">
          <li nz-menu-item nz-dropdown>
            <a nz-dropdown nzTrigger="click" class="hamburgerMenu" [nzDropdownMenu]="hamburgerMenu">
              <svg class="icon" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M29.9996 3.42212H1.99958C1.84244 3.42212 1.71387 3.55069 1.71387 3.70783V5.99355C1.71387 6.15069 1.84244 6.27926 1.99958 6.27926H29.9996C30.1567 6.27926 30.2853 6.15069 30.2853 5.99355V3.70783C30.2853 3.55069 30.1567 3.42212 29.9996 3.42212ZM29.9996 25.7078H1.99958C1.84244 25.7078 1.71387 25.8364 1.71387 25.9936V28.2793C1.71387 28.4364 1.84244 28.565 1.99958 28.565H29.9996C30.1567 28.565 30.2853 28.4364 30.2853 28.2793V25.9936C30.2853 25.8364 30.1567 25.7078 29.9996 25.7078ZM29.9996 14.565H1.99958C1.84244 14.565 1.71387 14.6935 1.71387 14.8507V17.1364C1.71387 17.2935 1.84244 17.4221 1.99958 17.4221H29.9996C30.1567 17.4221 30.2853 17.2935 30.2853 17.1364V14.8507C30.2853 14.6935 30.1567 14.565 29.9996 14.565Z"
                  fill="currentColor"
                />
              </svg>
            </a>
            <nz-dropdown-menu class="sidebar-container" #hamburgerMenu="nzDropdownMenu">
              <ul nz-menu class="hamburger-home">
                <li [routerLink]="['/home']" nz-menu-item nzSelected>
                  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_11610_2764)">
                      <path
                        d="M19.6999 9.84241L11.0749 1.22188L10.4967 0.64375C10.365 0.512895 10.1869 0.439453 10.0012 0.439453C9.81553 0.439453 9.6374 0.512895 9.50567 0.64375L0.302548 9.84241C0.167573 9.97686 0.0608995 10.137 -0.0111751 10.3133C-0.0832496 10.4897 -0.119265 10.6787 -0.117095 10.8692C-0.108166 11.6549 0.545851 12.2821 1.33157 12.2821H2.28023V19.5522H17.7222V12.2821H18.6909C19.0726 12.2821 19.432 12.1326 19.7021 11.8625C19.8351 11.7299 19.9405 11.5723 20.0121 11.3987C20.0838 11.2252 20.1203 11.0391 20.1195 10.8513C20.1195 10.4719 19.97 10.1125 19.6999 9.84241ZM11.2512 17.9451H8.75121V13.3915H11.2512V17.9451ZM16.115 10.675V17.9451H12.6798V12.8558C12.6798 12.3625 12.2802 11.9629 11.7869 11.9629H8.21549C7.72219 11.9629 7.32264 12.3625 7.32264 12.8558V17.9451H3.88737V10.675H1.74451L10.0034 2.42277L10.5191 2.93839L18.2601 10.675H16.115Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_11610_2764">
                        <rect width="20" height="20" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span>{{ 'navbar.menu.home' | translate }}</span>
                </li>
                <nz-divider nzText="{{ 'navbar.menu.assistance' | translate }}" nzOrientation="left"></nz-divider>
                <li [routerLink]="['/medical-consultations']" nz-menu-item>
                  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.3034 4.78181C17.2568 4.63852 17.1661 4.51364 17.0442 4.42504C16.9223 4.33644 16.7755 4.28865 16.6249 4.2885H14.9999V1.7885C14.9999 1.39342 14.6807 1.07422 14.2856 1.07422H5.71415C5.31906 1.07422 4.99986 1.39342 4.99986 1.7885V4.2885H3.37486C3.2241 4.2883 3.07716 4.33596 2.95521 4.42461C2.83327 4.51326 2.74261 4.63833 2.69629 4.78181L1.07129 9.77958V18.2171C1.07129 18.6122 1.39049 18.9314 1.78557 18.9314H18.2141C18.6092 18.9314 18.9284 18.6122 18.9284 18.2171V9.77958L17.3034 4.78181ZM6.607 2.68136H13.3927V4.2885H6.607V2.68136ZM17.3213 17.3242H2.67843V10.034L4.02441 5.89565H15.9753L17.3213 10.034V17.3242ZM13.1249 11.3421H10.7141V8.93136C10.7141 8.83315 10.6338 8.75279 10.5356 8.75279H9.46415C9.36593 8.75279 9.28558 8.83315 9.28558 8.93136V11.3421H6.87486C6.77665 11.3421 6.69629 11.4224 6.69629 11.5206V12.5921C6.69629 12.6903 6.77665 12.7706 6.87486 12.7706H9.28558V15.1814C9.28558 15.2796 9.36593 15.3599 9.46415 15.3599H10.5356C10.6338 15.3599 10.7141 15.2796 10.7141 15.1814V12.7706H13.1249C13.2231 12.7706 13.3034 12.6903 13.3034 12.5921V11.5206C13.3034 11.4224 13.2231 11.3421 13.1249 11.3421Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>{{ 'navbar.menu.medicalConsultations' | translate }}</span>
                </li>
                <li *ngIf="!functions.includes('MNF')" [routerLink]="['/assistance-service']" nz-menu-item>
                  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.87902 16.3379C2.87902 16.733 3.19822 17.0522 3.59331 17.0522H16.4058C16.8009 17.0522 17.1201 16.733 17.1201 16.3379V11.137C17.1201 7.20396 13.9326 4.01646 9.99956 4.01646C6.06652 4.01646 2.87902 7.20396 2.87902 11.137V16.3379ZM4.48617 11.137C4.48617 8.09236 6.95492 5.62361 9.99956 5.62361C13.0442 5.62361 15.513 8.09236 15.513 11.137V15.445H7.58885V11.6281C7.58885 11.5053 7.4884 11.4049 7.36563 11.4049H6.38349C6.26072 11.4049 6.16027 11.5053 6.16027 11.6281V15.445H4.48617V11.137ZM3.41251 5.50084L4.29643 4.61691C4.36563 4.54771 4.36563 4.43387 4.29643 4.36468L2.78081 2.84905C2.74725 2.81582 2.70192 2.79718 2.65469 2.79718C2.60746 2.79718 2.56214 2.81582 2.52858 2.84905L1.64465 3.73298C1.61142 3.76654 1.59277 3.81186 1.59277 3.8591C1.59277 3.90633 1.61142 3.95165 1.64465 3.98521L3.16027 5.50084C3.22947 5.57003 3.34108 5.57003 3.41251 5.50084ZM18.3589 3.73298L17.475 2.84905C17.4414 2.81582 17.3961 2.79718 17.3489 2.79718C17.3017 2.79718 17.2563 2.81582 17.2228 2.84905L15.7071 4.36468C15.6739 4.39824 15.6553 4.44356 15.6553 4.49079C15.6553 4.53802 15.6739 4.58335 15.7071 4.61691L16.5911 5.50084C16.6603 5.57003 16.7741 5.57003 16.8433 5.50084L18.3589 3.98521C18.4281 3.91378 18.4281 3.80218 18.3589 3.73298ZM17.1424 18.4807H2.8567C2.46161 18.4807 2.14242 18.7999 2.14242 19.195V19.7307C2.14242 19.829 2.22277 19.9093 2.32099 19.9093H17.6781C17.7763 19.9093 17.8567 19.829 17.8567 19.7307V19.195C17.8567 18.7999 17.5375 18.4807 17.1424 18.4807ZM9.37456 2.58789H10.6246C10.7228 2.58789 10.8031 2.50753 10.8031 2.40932V0.266462C10.8031 0.168248 10.7228 0.0878906 10.6246 0.0878906H9.37456C9.27635 0.0878906 9.19599 0.168248 9.19599 0.266462V2.40932C9.19599 2.50753 9.27635 2.58789 9.37456 2.58789Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>{{ 'navbar.menu.assistanceServices' | translate }}</span>
                </li>
                <nz-divider nzText="{{ 'navbar.menu.autonomy' | translate }}" nzOrientation="left"></nz-divider>
                <li [routerLink]="['/health-folder/medical-data']" nz-menu-item>
                  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M17.2889 8.71289L17.285 8.69726L15.0936 3.12891C14.9959 2.81445 14.7049 2.59766 14.3748 2.59766H5.49201C5.15998 2.59766 4.86506 2.81836 4.77131 3.13672L2.72248 8.64844L2.71662 8.66211L2.71271 8.67773C2.68732 8.77344 2.67951 8.87109 2.69318 8.9668C2.69123 8.99805 2.68927 9.0293 2.68927 9.06055V16.207C2.68979 16.5218 2.81507 16.8236 3.03766 17.0461C3.26024 17.2687 3.56199 17.394 3.87677 17.3945H16.1268C16.7811 17.3945 17.3143 16.8613 17.3162 16.207V9.06055C17.3162 9.03516 17.3162 9.00977 17.3143 8.98828C17.3221 8.89258 17.3143 8.80078 17.2889 8.71289ZM11.5115 7.87305L11.5057 8.17969C11.4901 9.05664 10.8846 9.64648 9.99982 9.64648C9.56818 9.64648 9.19709 9.50781 8.92951 9.24414C8.66193 8.98047 8.51545 8.61328 8.50763 8.17969L8.50177 7.87305H4.48224L6.03498 4.09766H13.8319L15.4276 7.87305H11.5115ZM4.18732 9.37305H7.25959C7.7342 10.4883 8.74396 11.1465 10.0018 11.1465C10.66 11.1465 11.2713 10.9629 11.7654 10.6152C12.199 10.3105 12.5369 9.88477 12.7557 9.37305H15.8123V15.8945H4.18732V9.37305Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>{{ 'navbar.menu.healthRecord' | translate }}</span>
                </li>
                <li *ngIf="functions.includes('MCK')" [routerLink]="['/symptom-assessment']" nz-menu-item>
                  <svg class="icon" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M19.6028 9.4255C17.4867 4.96791 14.2881 2.72461 10.0001 2.72461C5.70995 2.72461 2.51352 4.96791 0.39745 9.42773C0.312574 9.60746 0.268555 9.80375 0.268555 10.0025C0.268555 10.2013 0.312574 10.3976 0.39745 10.5773C2.51352 15.0349 5.71218 17.2782 10.0001 17.2782C14.2903 17.2782 17.4867 15.0349 19.6028 10.5751C19.7747 10.2134 19.7747 9.79381 19.6028 9.4255ZM10.0001 15.671C6.39968 15.671 3.76352 13.8451 1.90415 10.0014C3.76352 6.15765 6.39968 4.33175 10.0001 4.33175C13.6006 4.33175 16.2367 6.15765 18.0961 10.0014C16.239 13.8451 13.6028 15.671 10.0001 15.671ZM9.91084 6.07282C7.7412 6.07282 5.98227 7.83175 5.98227 10.0014C5.98227 12.171 7.7412 13.93 9.91084 13.93C12.0805 13.93 13.8394 12.171 13.8394 10.0014C13.8394 7.83175 12.0805 6.07282 9.91084 6.07282ZM9.91084 12.5014C8.52915 12.5014 7.41084 11.3831 7.41084 10.0014C7.41084 8.6197 8.52915 7.5014 9.91084 7.5014C11.2925 7.5014 12.4108 8.6197 12.4108 10.0014C12.4108 11.3831 11.2925 12.5014 9.91084 12.5014Z"
                      fill="currentColor"
                    />
                  </svg>
                  <span>{{ 'navbar.menu.symptomAssessment' | translate }}</span>
                </li>
              </ul>
            </nz-dropdown-menu>
          </li>
        </ul>
      </div>
      <div (click)="onLogoClick()" class="logo">
        <img [src]="logo" alt="Logo" class="logo-img" />
      </div>
      <div class="header-right">
        <ul nz-menu nzMode="horizontal" class="horizontal">
          <li nz-menu-item nz-dropdown class="user-menu-item">
            @if (secondUser) {
              <a class="user-menu" style="color: #e4002b" nz-dropdown nzTrigger="click" [nzDropdownMenu]="firstMenu">
                {{ secondUser.customer?.name + ' ' + secondUser.customer?.surname }} <i style="padding-left: 15px" nz-icon nzType="down"></i>
              </a>
            } @else {
              <a class="user-menu" nz-dropdown nzTrigger="click" [nzDropdownMenu]="firstMenu"> {{ userData.name }} <i style="padding-left: 15px" nz-icon nzType="down"></i> </a>
            }
            <nz-dropdown-menu class="user-menu-container" #firstMenu="nzDropdownMenu">
              <ul class="user-menu-dropdown" nz-menu>
                <li class="content" nz-menu-item [routerLink]="['/personal-area']">
                  <span nz-icon nzType="user" nzTheme="outline"></span>
                  <span>{{ 'navbar.userMenu.personalArea' | translate }}</span>
                </li>
                @if (isUserManagementAble && !secondUser) {
                  <li class="content" nz-menu-item [routerLink]="['/personal-area/profile-management']">
                    <span nz-icon nzType="setting" nzTheme="outline"></span>
                    <span>{{ 'navbar.userMenu.profileManagement' | translate }}</span>
                  </li>
                  @if (users?.relatedProfiles) {
                    <div class="related-profiles">
                      @for (user of users?.relatedProfiles; track $index) {
                        @if (user.isChangeProfileEnabled) {
                          <li (click)="changeUser(user)" class="content users" nz-menu-item>
                            <span>{{ user.fullName }}</span>
                          </li>
                        }
                      }
                    </div>
                  }
                  @if (isUserManagementAble) {
                    <div class="related-profiles">
                      <nz-divider nzPlain></nz-divider>
                      <li class="content" nz-menu-item (click)="redirect()">
                        <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
                        <span>{{ 'navbar.userMenu.addUser' | translate }}</span>
                      </li>
                    </div>
                  }
                }
                <li class="content" nz-menu-item (click)="onLogout()">
                  <span nz-icon nzType="logout" nzTheme="outline"></span>
                  <span>{{ 'navbar.userMenu.logout' | translate }}</span>
                </li>
              </ul>
            </nz-dropdown-menu>
          </li>
          <li nz-menu-item class="user-menu-mobile">
            <a class="user-menu-link" nz-dropdown nzTrigger="click" [nzDropdownMenu]="mobileuserMenu">
              @if (secondUser) {
                <span> {{ getInitials(secondUser.customer?.name) + ' ' + getInitials(secondUser.customer?.surname) }}</span>
              } @else {
                <span>{{ getInitials(userData.name) }}</span>
              }
              <img class="arrow-down" src="../../../../public/assets/images/DownOutlined.svg" alt="" />
            </a>
          </li>
          <nz-dropdown-menu #mobileuserMenu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item [routerLink]="['/personal-area']">
                <span nz-icon nzType="user" nzTheme="outline"></span>
                <span>{{ 'navbar.userMenu.personalArea' | translate }}</span>
              </li>
              @if (isUserManagementAble && !secondUser) {
                <li nz-menu-item [routerLink]="['/personal-area/profile-management']">
                  <span nz-icon nzType="setting" nzTheme="outline"></span>
                  <span>{{ 'navbar.userMenu.profileManagement' | translate }}</span>
                </li>
                <div style="background-color: #f2f5fe; padding: 10px 0">
                  @if (users?.relatedProfiles) {
                    <div class="related-profiles">
                      @for (user of users?.relatedProfiles; track $index) {
                        @if (user.isChangeProfileEnabled) {
                          <li (click)="changeUser(user)" class="content users" nz-menu-item>
                            <span>{{ user.fullName }}</span>
                          </li>
                        }
                      }
                    </div>
                  }
                  @if (isUserManagementAble) {
                    <div class="related-profiles">
                      <nz-divider nzPlain></nz-divider>
                      <li class="content add-user" nz-menu-item (click)="redirect()">
                        <span nz-icon nzType="plus-circle" nzTheme="outline"></span>
                        <span>{{ 'navbar.userMenu.addUser' | translate }}</span>
                      </li>
                    </div>
                  }
                </div>
              }
              <li nz-menu-item class="logout-mobile" (click)="onLogout()">
                <span nz-icon nzType="logout" nzTheme="outline"></span>
                <span>{{ 'navbar.userMenu.logout' | translate }}</span>
              </li>
            </ul>
          </nz-dropdown-menu>
          <li nz-menu-item class="notification-icon" (click)="showNotifications()">
            <nz-badge [nzCount]="notificationCount">
              <svg class="icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M20.1419 18.8538H19.499V9.74665C19.499 5.96719 16.7053 2.84397 13.0705 2.32433V1.28237C13.0705 0.690402 12.591 0.210938 11.999 0.210938C11.4071 0.210938 10.9276 0.690402 10.9276 1.28237V2.32433C7.29277 2.84397 4.49902 5.96719 4.49902 9.74665V18.8538H3.85617C3.38206 18.8538 2.99902 19.2368 2.99902 19.7109V20.5681C2.99902 20.6859 3.09545 20.7824 3.21331 20.7824H8.99902C8.99902 22.4377 10.3437 23.7824 11.999 23.7824C13.6544 23.7824 14.999 22.4377 14.999 20.7824H20.7847C20.9026 20.7824 20.999 20.6859 20.999 20.5681V19.7109C20.999 19.2368 20.616 18.8538 20.1419 18.8538ZM11.999 22.0681C11.2892 22.0681 10.7133 21.4922 10.7133 20.7824H13.2847C13.2847 21.4922 12.7088 22.0681 11.999 22.0681ZM6.4276 18.8538V9.74665C6.4276 8.25737 7.00617 6.85915 8.05885 5.80647C9.11152 4.75379 10.5097 4.17522 11.999 4.17522C13.4883 4.17522 14.8865 4.75379 15.9392 5.80647C16.9919 6.85915 17.5705 8.25737 17.5705 9.74665V18.8538H6.4276Z"
                  fill="currentColor"
                />
              </svg>
            </nz-badge>
          </li>
          <li nz-menu-item nz-dropdown class="language-menu-item">
            <a nz-dropdown [nzDropdownMenu]="languageMenu">
              <strong>{{ this.selectedLang.toUpperCase() }} </strong><i nz-icon nzType="down"></i>
            </a>
            <nz-dropdown-menu #languageMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="onLanguageChange('it')">
                  <strong>{{ 'navbar.lang.it' | translate }}</strong>
                </li>
                <li nz-menu-item (click)="onLanguageChange('en')">
                  <strong>{{ 'navbar.lang.en' | translate }}</strong>
                </li>
              </ul>
            </nz-dropdown-menu>
          </li>
        </ul>
      </div>
    } @else {
      <div [ngStyle]="{ display: currentUrl && currentUrl.includes('/login') ? 'none' : 'inline-block' }">
        <div class="hamburger-menu not-logged-menu">
          <ul nz-menu nzMode="horizontal">
            <li nz-menu-item nz-dropdown>
              <a nz-dropdown nzTrigger="click" class="hamburgerMenu" [nzDropdownMenu]="notLoggedMenu">
                <img src="../../../../public/assets/images/hamburge-menu.svg" alt="menu" />
              </a>

              <nz-dropdown-menu #notLoggedMenu="nzDropdownMenu" class="sidebar-container">
                <ul nz-menu class="mobile-menu-content">
                  <span class="sections-text">SEZIONI</span>
                  <div style="height: 88vh">
                    <li [routerLink]="['/activation']" nz-menu-item class="activation-mobile">
                      <img src="../../../../public/assets/images/icon_code.svg" alt="" />
                      <span>{{ 'navbar.active_code' | translate }}</span>
                    </li>

                    <li nz-menu-item class="cta-button" style="position: fixed; bottom: 20px; width: 95%; display: flex; justify-content: center" (click)="goToLogin()">
                      <a
                        style="
                          display: block;
                          background-color: var(--buttons-color);
                          color: #f2f5fe !important;
                          text-align: center;
                          border-radius: 24px;
                          text-decoration: none;
                          padding: 9px 24px;
                          height: 40px;
                          width: 320px;
                        "
                        >{{ 'buttons.customer_area' | translate }}
                        <img src="../../../../public/assets/images/user_white.svg" alt="" />
                      </a>
                    </li>
                  </div>
                </ul>
              </nz-dropdown-menu>
            </li>
          </ul>
        </div>
      </div>

      <div (click)="onLogoClick()"class="logo">
        <img [src]="logo" alt="Logo" class="logo-img" />
      </div>
      <div *ngIf="!currentUrl?.includes('/login') && !maintenanceMode" nz-menu nzMode="horizontal" [routerLink]="['/activation']" nz-menu-item class="desktop">
        <img src="../../../../public/assets/images/icon_code.svg" alt="" />
        <span>{{ 'navbar.active_code' | translate }}</span>
      </div>
      <div class="container-desktop">
        <div class="desktop customer-btn">
          <ds-button
            *ngIf="!currentUrl?.includes('/login') && !maintenanceMode"
            [text]="'buttons.customer_area' | translate"
            [width]="'small'"
            [iconRight]="'/public/assets/images/user-white.svg'"
            [routerLink]="['/login']"
          >
          </ds-button>

          <div *ngIf="currentUrl?.includes('/login') || maintenanceMode" class="simple-customer-text">
            <span>Area clienti</span>
            <img src="/public/assets/images/user-black.svg" alt="icon" style="margin-left: 8px" />
          </div>
        </div>
        <ul nz-menu nzMode="horizontal">
          <li nz-menu-item nz-dropdown class="language-menu-item">
            <a nz-dropdown [nzDropdownMenu]="languageMenu"
              ><strong>{{ this.selectedLang.toUpperCase() }} </strong> <i nz-icon nzType="down"></i>
            </a>
            <nz-dropdown-menu #languageMenu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item (click)="onLanguageChange('it')">
                  <strong>{{ 'navbar.lang.it' | translate }}</strong>
                </li>
                <li nz-menu-item (click)="onLanguageChange('en')">
                  <strong>{{ 'navbar.lang.en' | translate }}</strong>
                </li>
              </ul>
            </nz-dropdown-menu>
          </li>
        </ul>
      </div>
    }
  </div>
</nz-header>
